import { render, staticRenderFns } from "./flows-list.vue?vue&type=template&id=6b1cf8fa&scoped=true"
import script from "./flows-list.vue?vue&type=script&lang=js"
export * from "./flows-list.vue?vue&type=script&lang=js"
import style0 from "./flows-list.vue?vue&type=style&index=0&id=6b1cf8fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1cf8fa",
  null
  
)

export default component.exports